/* eslint-disable @typescript-eslint/unbound-method */
/* eslint-disable @typescript-eslint/no-unsafe-argument */

import { CalendarApi } from "@/apis/clients";
import { wrap } from "@/apis/wrap";

const calendarApi = {
  index: wrap(CalendarApi, CalendarApi.prototype.getCalendar),
  getCalendarCopyTimes: wrap(CalendarApi, CalendarApi.prototype.getCalendarCopyTimes),
  getCalendarMenus: wrap(CalendarApi, CalendarApi.prototype.getCalendarMenus),
};

export default calendarApi;
